import { Box } from '@factorialco/deprecated-design-system'
import { BarChart } from '@factorialco/f0-react'

type ChartData = {
  status?: string
  color?:
    | 'categorical-1'
    | 'categorical-2'
    | 'categorical-3'
    | 'categorical-4'
    | 'categorical-5'
    | 'categorical-6'
    | 'categorical-7'
    | 'categorical-8'
    | 'feedback-positive'
    | 'feedback-negative'
    | 'feedback-neutral'
  label: string
  value: { [key: string]: number }
  formattedValue?: string
}

interface BarChartWrapperProps {
  groupedChartData: ChartData[]
  barLabels: { [key: string]: { label: string; color?: string } }
  tickFormatter: (value: string) => string
  type: 'stacked' | 'stacked-by-sign' | 'simple'
  aspect: 'small' | 'wide'
  displayAxis?: boolean
}

export const BarChartWrapper = ({
  groupedChartData,
  barLabels,
  tickFormatter,
  type,
  aspect,
  displayAxis = true,
}: BarChartWrapperProps) => {
  const barChartData = groupedChartData.map((x) => ({
    label: x.label,
    values: x.value,
  }))

  return (
    <Box width="full" height="full">
      <BarChart
        data={barChartData}
        dataConfig={barLabels}
        type={type}
        xAxis={{
          hide: !displayAxis,
        }}
        yAxis={{
          hide: !displayAxis,
          tickFormatter,
        }}
        aspect={aspect}
      />
    </Box>
  )
}
